<template>
  <div
    :class="$style.wrapper"
    @click="handleWrapperClick"
  >
    <QuestProgress is-claim-button-shown />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import QuestProgress from './QuestProgress'
export default {
  name: 'MakeRosterQuestLobby',
  components: { QuestProgress },
  methods: {
    ...mapActions({
      openQuestMakeRosterModal: 'quests/makeRosterQuest/openQuestMakeRosterModal',
    }),
    handleWrapperClick() {
      this.openQuestMakeRosterModal()
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .wrapper {
    cursor: pointer;
    padding: .5rem;
  }
</style>
